import { Button } from '../../primitives';
import { BaseModal } from './BaseModal';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  description?: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

export const ConfirmModal = ({
  open,
  title,
  description,
  onConfirm,
  onCancel,
  confirmText = 'Xác nhận',
  cancelText = 'Huỷ',
  loading = false,
}: ConfirmModalProps) => {
  return (
    <BaseModal
      open={open}
      title={title}
      description={description}
      onClose={onCancel}
      actions={
        <>
          <Button variant="outlined" onClick={onCancel} disabled={loading}>
            {cancelText}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            loading={loading}
          >
            {confirmText}
          </Button>
        </>
      }
    />
  );
};